module.exports = __webpack_public_path__ + "/static/assets/21988681fa28c8ce37982ca26463a6f5.svg";